/* Purpose: Admins can view a list of all clients or a list of all loans for all cliens.
 *          When click on a specific client, (or a loan from a specific client)
 *          admin can review clients info and download submitted files
 * Props: GlobalVar (map)
 *          AdminID (str)
 *          username (str)
 *          credentials (map)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React, {useState, useEffect} from 'react';
import PageTitle from '../../Components/PageTitle';
import SubmitButton from '../../Components/Button';
import { Row, Container, Card, Col, Form, Badge, Stack } from 'react-bootstrap';
import Review from '../Portal/Review';
import AdminClients from '../../Components/AdminClients';
import AdminLoans from '../../Components/AdminLoans';
import { file } from 'jszip';

const ClientList = (props) => {
    const [allClients, setAllClients] = useState([{"Personal":{"First Name": "Loading", "Last Name": "...", "Email": "Loading ..."}}]);
    const AdminID = props.AdminID;
    const credentials = props.credentials;
    const username = props.username;
    
    const [needRefresh, setNeedRefresh] = useState(true);
    const [refreshText, setRefreshText] = useState("Refresh")
    const [chosenClient, setChosenClient] = useState(null);
    const [sortSelection, setSortSelection] = useState("AZ")
    const [viewSelection, setViewSelection] = useState("Clients")
    const [allLoans, setAllLoans] = useState()
        
    // Get all clients from the Client table of db. Sort the clients A > Z by last name
    useEffect (() => {
        const getAllClients = async () => {
            try {
                const response = await fetch("https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/getAllClientsWithLoanBasicInfo", {
                    "method": "POST",
                    "body":JSON.stringify({
                        "credentials": credentials
                    })
                })
                if (response.ok){
                    let data = await response.json();
                    // console.log("ClientList response data ", data)

                    data.forEach((client, index) => {
                        let newLoans = 0;
                        if (client.Loans){
                            Object.keys(client.Loans).forEach((LoanID) => {
                                if(client.Loans[LoanID].isNew){
                                    newLoans += 1;
                                }
                            })
                        }
                        
                        data[index] = {...data[index],
                            "newLoans":newLoans}
                    })
                    handleSortChange("AZ", data, "Clients")
                    setRefreshText("Refresh")

                    let tempAllLoans = [];
                    data.forEach((client, index) => {
                        client.Loans.forEach((loan, loanIndex) => {
                            tempAllLoans.push({...loan, 
                                "ClientName": client.Personal['First Name'] + " " + client.Personal['Last Name'],
                                "Email": client.Personal['Email'],
                                "ClientID" :client.ClientID,
                                "ClientIndex": index
                                }
                            )
                        })
                    });
                    setAllLoans(tempAllLoans)
                    
                }else{
                    console.error("Something went wrong when getting a list of all the users.")
                    setAllClients([{Personal: {"First Name": "Something went wrong when getting a list of all the users. DO NOT try to view data.", Email: "Error", Loans: {}}}])
                    setRefreshText("Refresh")
                }
           
            }catch (error){
                        console.log("Something went wrong when getting a list of all the users. ", error);
                        setAllClients([{Personal: {"First Name": "Something went wrong when getting a list of all the users. DO NOT try to view data.", Email: "Error", Loans: {}}}])
                        setRefreshText("Refresh")

            }

        };
        if(needRefresh){
            setRefreshText("Refreshing...")
            getAllClients();
            handleViewChange("Clients")
            setNeedRefresh(false);
        }
        
    }, [needRefresh]);

    // When Click View Data (or View Client's Data)
    const handleViewData = (client) => {
        setChosenClient(client);
    };
     
    // When a different view option is selected, change the display
    const handleViewChange = (value) => {
        setViewSelection(value)
        if (value == "Loans"){
            handleSortChange("AZ", allLoans, "Loans")
        }else{
            handleSortChange("AZ", allClients, "Clients")
        }

        
    }

    // When a different sort option is selected, resort the data being displayed
    const handleSortChange = (value, data, view) => {
        setSortSelection(value)


        if(!view){
            view = viewSelection;
        }

        if (!data){
            data = view == "Clients"?[...allClients]:[...allLoans]
        }

        if (value == "AZ"){
            // Last Name A to Z
            data.sort((a, b) => {
                let bText = view == "Clients"?(b.Personal["Last Name"].toLowerCase() || ''):(b.LoanID)
                let aText = view == "Clients"?(a.Personal["Last Name"].toLowerCase() || ''):(a.LoanID)

                if (aText > bText){
                    return 1
                }else if (aText < bText){
                    return -1
                }else{
                    return 0
                }
            })

        }else if(value == "ZA"){
            // Last Name Z to A
            data.sort((a, b) => {
                let bText = view == "Clients"?(b.Personal["Last Name"].toLowerCase() || ''):(b.LoanID)
                let aText = view == "Clients"?(a.Personal["Last Name"].toLowerCase() || ''):(a.LoanID)

                if (aText > bText){
                    return -1
                }else if (aText < bText){
                    return 1
                }else{
                    return 0
                }
            })

        }else if (value == "12"){
            data.sort((a, b) => {
                if (view == "Clients"){
                    if (!a.Loans || a.Loans.length < 1){
                        return -1
                    }else if(!b.Loans || b.Loans.length < 1){
                        return 1
                    }else{
                        b.Loans.sort((c, d) => {
                            let cDate = new Date(c.DateCreated);
                            let dDate = new Date(d.DateCreated);

                            if (cDate > dDate){
                                return 1
                            }else if (cDate < dDate){
                                return -1
                            }else{
                                return 0
                            }
                        })

                        a.Loans.sort((c, d) => {
                            let cDate = new Date(c.DateCreated);
                            let dDate = new Date(d.DateCreated);

                            if (dDate > cDate){
                                return 1
                            }else if (dDate < dDate){
                                return -1
                            }else{
                                return 0
                            }
                        })
                    }}

                const oldestB = new Date(view == "Clients"?b.Loans[0]['DateCreated']:b.DateCreated);
                const oldestA = new Date(view == "Clients"?a.Loans[0]['DateCreated']:a.DateCreated);

                if (oldestA > oldestB){
                    return 1
                }else if (oldestA < oldestB){
                    return -1
                }else{
                    return 0
                }
            })

        }else if(value == "21"){
            // Date created New to Old
            data.sort((a, b) => {
                if (view == "Clients"){
                    if (!a.Loans || a.Loans.length < 1){
                        return 1
                    }else if(!b.Loans || b.Loans.length < 1){
                        return -1
                    }else{
                        b.Loans.sort((c, d) => {
                            let cDate = new Date(c.DateCreated);
                            let dDate = new Date(d.DateCreated);

                            if (cDate > dDate){
                                return -1
                            }else if (cDate < dDate){
                                return 1
                            }else{
                                return 0
                            }
                        })

                        a.Loans.sort((c, d) => {
                            let cDate = new Date(c.DateCreated);
                            let dDate = new Date(d.DateCreated);

                            if (dDate > cDate){
                                return -1
                            }else if (dDate < dDate){
                                return 1
                            }else{
                                return 0
                            }
                        })
                    }
                }
                const oldestB = new Date(view == "Clients"?b.Loans[0]['DateCreated']:b.DateCreated);
                const oldestA = new Date(view == "Clients"?a.Loans[0]['DateCreated']:a.DateCreated);

                if (oldestA > oldestB){
                    return -1
                }else if (oldestA < oldestB){
                    return 1
                }else{
                    return 0
                }
                
            })

        }

        if (view == "Clients"){
            setAllClients(data)
        }else{
            setAllLoans(data)
        }
        

    }

    


    // After clicking veiw data, if click return to client list, 
    // will set chosen client to null to stop displaying Review page
    const handleReturnToClientList = () => {
        setChosenClient(null);
    }

    // Update the isNew attribute of a loan.
    // (This is automatically called when a new loan is clicked by an admin on the Review page)
    // Sets isNew to false in db and decreases the number of new loans by one
    const updateLoanReviews = async (ClientID, LoanID) => {
        let tempAllClients = [...allClients];
        let clientIndex;
        tempAllClients.forEach((client, index) => {
            if (client.ClientID == ClientID){
                clientIndex = index
            }
        })
        tempAllClients[clientIndex]['Loans'].find((loan) => loan.LoanID === LoanID).isNew = false
        tempAllClients[clientIndex]['newLoans'] -= 1

        setAllClients(tempAllClients)

        // update the reviewed status in dynamodb
        try{
            const response = await fetch("https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/updateIsNew",{
                "method": "POST",
                "body": JSON.stringify({
                    "ClientID": ClientID,
                    "LoanID": LoanID,
                    "credentials": credentials
                })
            });

            // If everything went smoothly, nothing happens (it is annoying for the user to be notified)
            // If something goes wrong, the user will be notified.
            if (!response.ok){
                let error = await response.json();
                error = error['body'];
                alert(error);
            }
        }catch(e){
            alert(e);
            console.log(e)
        }
    }

    // By clicking Update Loan status on Review page and confirming through the ConfirmStatusUpdate modal,
    // The loan status will be updated (automatically to one step forward) in db
    const updateLoanStatus = async(ClientID, LoanID, currentStatus, setLoanBasicInfo) => {
        if (currentStatus != "Approved"){
            let tempAllClients = [...allClients];
            let clientIndex;
            tempAllClients.forEach((client, index) => {
                if (client.ClientID == ClientID){
                    clientIndex = index
                }
            })
            let loanIndex = tempAllClients[clientIndex]['Loans'].findIndex((loan) => loan.LoanID === LoanID)

            let tempAllLoans = [...allLoans]
            let loanIndexAll = tempAllLoans.findIndex((loan) => loan.LoanID === LoanID)

            if (currentStatus == "Intake"){
                tempAllClients[clientIndex]['Loans'][loanIndex].Status = "Processing"
                tempAllLoans[loanIndexAll].Status = "Processing"
            } else if ( currentStatus == "Processing"){
                tempAllClients[clientIndex]['Loans'][loanIndex].Status = "Underwriting"
                tempAllLoans[loanIndexAll].Status = "Underwriting"
            }else if (currentStatus == "Underwriting"){
                tempAllClients[clientIndex]['Loans'][loanIndex].Status = "Approved"
                tempAllLoans[loanIndexAll].Status = "Approved"
            }

            setAllLoans(tempAllLoans)
            setAllClients(tempAllClients)
            setLoanBasicInfo(tempAllLoans[loanIndexAll])

            // Update the loan status in dynamodb
            try{
                const response = await fetch("https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/updateLoanStatus",{
                    "method": "POST",
                    "body": JSON.stringify({
                        "ClientID": ClientID,
                        "LoanID": LoanID,
                        "currentStatus": currentStatus,
                        "credentials": credentials
                    })
                });

                // If everything went smoothly, nothing happens (it is annoying for the user to be notified)
                // If something goes wrong, the user will be notified.
                if (!response.ok){
                    let error = await response.json();
                    error = error['body'];
                    alert(error);
                }
            }catch(e){
                alert(e);
                console.log(e)
            }
        }
    }

    return(
        <div className='align-items-center'>
            {!chosenClient && (
                <div>
                    <PageTitle pageName = {viewSelection} />
                    <Container>
                        <Row className='mt-3 mx-5' xs = {1} sm = {3} md = {4}>
                            <Col>
                                <SubmitButton text = {refreshText} onClick = {() => setNeedRefresh(true)} width = "auto" />
                            </Col>
                            <Col>
                                <Col xs='auto'>
                                    <Form.Label>View: </Form.Label>
                                </Col>
                                <Col xs = 'auto'>
                                    <Form.Select aria-label="view-options" value = {viewSelection} onChange = {(event) => handleViewChange(event.currentTarget.value)}>
                                        <option value="Clients" >Clients</option>
                                        <option value="Loans">Loans</option>
                                    </Form.Select>
                                </Col>
                            </Col>
                            <Col>
                                <Col xs='auto'>
                                    <Form.Label>Sort: </Form.Label>
                                </Col>
                                <Col xs = 'auto'>
                                    <Form.Select aria-label="sort-options" value = {sortSelection} onChange = {(event) => handleSortChange(event.currentTarget.value)}>
                                        <option value="AZ" >A to Z</option>
                                        <option value="ZA">Z to A</option>
                                        <option value="12">Loans - Old to New</option>
                                        <option value="21">Loans - New to Old</option>
                                    </Form.Select>
                                </Col>
                            </Col>
                        </Row>
                        {(allClients && allLoans) && viewSelection == "Clients"? (
                            <AdminClients allClients={allClients} handleViewData={handleViewData}/>
                        ):(
                            <>
                            {allLoans!=[{"LoanID": "Loading..."}] && (<AdminLoans 
                                allClients = {allClients} 
                                setAllClients = {setAllClients}
                                allLoans = {allLoans} 
                                setAllLoans={setAllLoans}
                                handleViewData={handleViewData}
                                credentials={credentials}
                                username = {username}
                             />)}
                             </>
                        )}
                    </Container>
                </div>
            )}

        {chosenClient && (
            <div>
                <Review 
                    ClientID = {chosenClient.ClientID} 
                    AdminID = {AdminID} 
                    adminUsername = {username}
                    clientInfo = {chosenClient} 
                    credentials = {credentials}
                    allLoans = {allLoans}
                    setAllLoans = {setAllLoans}
                    allClients = {allClients}
                    setAllClients = {setAllClients}
                    updateLoanReviews = {updateLoanReviews}
                    updateLoanStatus = {updateLoanStatus}
                />

                <SubmitButton text = "Return to list of clients" onClick = {handleReturnToClientList} />
            </div>
        )}

        </div>
    );
};

export default ClientList;